<template>
  <div id="container" style="width: 100%;height: calc(100vh - 137px)"></div>
</template>
<script>
import BMap from "BMap";
export default {
  data() {
    return {
      ak: "UaQ8dNlAtcYcjbV2stcesustAPm1mDUe"
    };
  },
  mounted() {
    var map = new BMap.Map("container");
    var point = new BMap.Point(116.798401, 33.9557);
    map.addControl(
      new BMap.MapTypeControl({
        mapTypes: [
          BMAP_NORMAL_MAP,
          BMAP_HYBRID_MAP,
          BMAP_NORMAL_MAP
          //   BMAP_ANIMATION_BOUNCE,
          //   BMAP_UNIT_METRIC,
          //   BMAP_POI_TYPE_BUSSTOP,
          //   BMAP_POI_TYPE_SUBSTOP
        ]
      })
    );
    map.addControl(new BMap.ScaleControl());
    map.setCurrentCity("淮北");
    map.enableScrollWheelZoom(true);
    map.centerAndZoom(point, 16);
  }
};
</script>
